"use client";

import { useCallback, useSyncExternalStore } from "react";

import type { Currency } from "./currency-toggle";

const STORAGE_KEY = "models-currency";

function getSnapshot(): Currency {
	// USD-only deployment — pricing is always shown in USD.
	return "usd";
}

function getServerSnapshot(): Currency {
	return "usd";
}

const listeners = new Set<() => void>();

function subscribe(callback: () => void) {
	listeners.add(callback);
	return () => listeners.delete(callback);
}

function setCurrency(currency: Currency) {
	localStorage.setItem(STORAGE_KEY, currency);
	listeners.forEach((listener) => listener());
}

export function useCurrency(): [Currency, (c: Currency) => void] {
	const currency = useSyncExternalStore(
		subscribe,
		getSnapshot,
		getServerSnapshot,
	);
	const set = useCallback((c: Currency) => setCurrency(c), []);
	return [currency, set];
}
